import { EQuizMode } from '@constants';
import { Flex } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { QuizActivitySelector } from '../QuizActivitySelector';

import { QuizLinkButton } from './QuizLinkButton';
import { LinkWrapper, SubtitleWrapper } from './QuizType.styles';

import { Animated } from '@/components/Animated';
import { useActivityForm } from '@/store';
import { handleInputValue } from '@/utils';

type Props = {
  value?: { quiz: string | { _id: string; title?: string; mode?: string } };
  onChange?: ({ quiz }: { quiz: string }) => void;
};

export const QuizType: React.FC<Props> = ({ value, onChange }) => {
  const { _id } = useParams<{ _id: string }>();
  const { t } = useTranslation('StudentQuizTranslations');
  const { setIsOpen: setIsQuizFormOpen } = useActivityForm();
  const handleChange = (quiz: string) => onChange?.({ quiz });
  const navigateTo = useNavigate();

  const handleNavigateToTests = () => navigateTo(`/evaluation/tests`);

  const quizId = handleInputValue(value?.quiz);

  const handleNavigateToQuizDetail = () => {
    setIsQuizFormOpen(false);
    navigateTo(`/evaluation/tests/${quizId}/edit`);
  };

  return (
    <>
      <SubtitleWrapper>
        <Trans
          i18nKey="TEACHERS_CREATE_QUIZ_LINK"
          components={{ a: <LinkWrapper onClick={handleNavigateToTests} /> }}
        />
      </SubtitleWrapper>

      <Flex gap={8} align="center" style={{ width: '100%' }}>
        {quizId && <QuizLinkButton onClick={handleNavigateToQuizDetail} />}

        <Animated style={{ width: '100%' }}>
          <QuizActivitySelector
            courseId={_id}
            onChange={handleChange}
            value={quizId}
            fallbackLabel={
              value?.quiz && typeof value.quiz === 'object'
                ? `(${t(value.quiz.mode as EQuizMode)}) - ${value.quiz.title}`
                : undefined
            }
            allowClear
          />
        </Animated>
      </Flex>
    </>
  );
};
